export default {
  labels: {
    in_store_card_payments_not_supported: '⚠️ Alleen contant in het restaurant. Kaartbetaling niet geaccepteerd.',
  },
};
